module.exports = __webpack_public_path__ + "img/sld_mfm_inv_3_t1_b1_dark.9e13e6ac.svg";